import { render, staticRenderFns } from "./CartaoPerfil.vue?vue&type=template&id=7dc217fa&scoped=true"
import script from "./CartaoPerfil.vue?vue&type=script&lang=js"
export * from "./CartaoPerfil.vue?vue&type=script&lang=js"
import style0 from "./CartaoPerfil.vue?vue&type=style&index=0&id=7dc217fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc217fa",
  null
  
)

export default component.exports